import Vue from "vue";

import "./styles/quasar.sass";
import iconSet from "quasar/icon-set/fontawesome-v5.js";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/material-icons-outlined/material-icons-outlined.css";
import "@quasar/extras/material-icons-round/material-icons-round.css";
import "@quasar/extras/material-icons-sharp/material-icons-sharp.css";
import "@quasar/extras/fontawesome-v5/fontawesome-v5.css";
import "@quasar/extras/ionicons-v4/ionicons-v4.css";
import "@quasar/extras/mdi-v4/mdi-v4.css";
import "@quasar/extras/eva-icons/eva-icons.css";

// import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';import BottomSheet from 'quasar/src/plugins/BottomSheet.js';import Intersection from 'quasar/src/directives/Intersection.js';;
import Quasar from 'quasar/src/vue-plugin.js';import Intersection from 'quasar/src/directives/Intersection.js';import Dialog from 'quasar/src/plugins/Dialog.js';;

import {
  // QAvatar,
  // QBar,
  QBtn,
  // QMenu,
  // QBtnToggle,
  // QBadge,
  // QCard,
  // QCardSection,
  // QCardActions,
  // QCarousel,
  // QCarouselControl,
  // QCarouselSlide,
  // QCheckbox,
  // QDialog,
  // QExpansionItem,
  // QForm,
  QIcon,
  // QInput,
  QImg,
  // QInfiniteScroll,
  QItem,
  QItemSection,
  // QList,
  // QOptionGroup,
  // QTab,
  // QTabs,
  // QTabPanel,
  // QTabPanels,
  // QToggle,
  // QToolbar,
  // QTooltip,
  // QScrollArea,
  QSelect,
  // QSeparator,
  // QSkeleton,
  // QSpinner,
  // QSpinnerHourglass,
  // QSpinnerDots,
  QSpace,
  // QRadio,
  // QResponsive,
  // QRouteTab,
} from "quasar";

const components = {
  //     QAvatar,
  //     QBar,
  QBtn,
  //     QMenu,
  //     QBtnToggle,
  //     QBadge,
  //     QCard,
  //     QCardSection,
  //     QCardActions,
  //     QCarousel,
  //     QCarouselControl,
  //     QCarouselSlide,
  //     QCheckbox,
  //     QDialog,
  //     QExpansionItem,
  //     QForm,
  QIcon,
  //     QInput,
  QImg,
  //     QInfiniteScroll,
  QItem,
  QItemSection,
  //     QList,
  //     QOptionGroup,
  //     QTab,
  //     QTabs,
  //     QTabPanel,
  //     QTabPanels,
  //     QToggle,
  //     QToolbar,
  //     QTooltip,
  //     QScrollArea,
  QSelect,
  //     QSeparator,
  //     QSkeleton,
  //     QSpinner,
  //     QSpinnerHourglass,
  //     QSpinnerDots,
  QSpace,
  //     QRadio,
  //     QResponsive,
  //     QRouteTab,
};

import ClosePopup from 'quasar/src/directives/ClosePopup.js';import Scroll from 'quasar/src/directives/Scroll.js';;

const directives = {
  ClosePopup,
  Intersection,
  Scroll,
};

Vue.use(Quasar, {
  config: {
    brand: {
      primary: "#2c2a74",
      secondary: "#fcfaeb",
      accent: "#ED7246",
      dark: "#575757",
      positive: "#009e7e",
      negative: "#c72027",
      info: "#f2f3f4",
      warning: "#f2e857",
    }
  },
  components,
  directives,
  plugins: {
    Dialog
  },
  iconSet: iconSet,
  
});
